import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import router from './routes/routes'
import axios from 'axios';
import store from './vuex/store.js';
import * as dateutils from './DateTimeUtils.js'
import * as patientLinkUtils from './PatientLinkUtils';

require('./css/style.css');
require('./css/font-styles.css');
Vue.config.productionTip = false;

// Prototypes
Vue.prototype.axios = axios;
Vue.prototype.moment = dateutils.moment;
Vue.prototype.dateutils = dateutils;
Vue.prototype.patientLinkUtils = patientLinkUtils;
Vue.prototype.google_map_key = 'AIzaSyDOyusaWsBwcacnHMSNe40r8PowTwC8cHA'

// Vue.prototype.$vueEventBus = new Vue();

Vue.use(VueRouter);


import { ValidationProvider, ValidationObserver, setInteractionMode, extend } from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
setInteractionMode('eager');

import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
extend('required', {
    message: '{_field_} is required'
})
extend('length', {
    message: '{_field_} must be {length} characters long'
})
extend('min', {
    message: '{_field_} must be at least {length} characters long'
})
extend('max', {
    message: '{_field_} must be at most {length} characters long'
})
extend('size', {
    message: '{_field_} must be less than {size} kb'
})





axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.interceptors.response.use(null, function(error) {
    switch(error.response.status) {
        case 401:
            store.dispatch('userLogout').then(() => {
                var current_url = window.location.href
                var base_url = window.location.origin
                var urlObj = new URL(base_url)
                urlObj.searchParams.set('redirect', current_url);
                window.location.replace(urlObj.href)
            })
            break
        case 403:
            //
            break
        case 404:
            //
            break
        case 422:
            for(let i in error.response.data.errors) {
                store.commit('showSnackbar', {message: error.response.data.errors[i][0]})
            }
            // var toastMessage = ""
            // if(error.response.data.errors){
            //     var errs = error.response.data.errors
            
            //     var err_values = Object.values(errs)
            //     var errArr = []
            //     err_values.forEach(function(entry) {
            //         entry.forEach(function(val) {
            //             errArr.formErrors.push(val);
            //         });                        
            //     }); 
            //     toastMessage = errArr.explode(',')
            // }
            // else if(error.response.data.message){
            //     toastMessage = error.response.data.message
            // }
            
            // if(toastMessage)
            //     store.commit('showSnackbar', {message:toastMessage})            

            
            break
        case 429:
            //
            break
        default:
            // store.commit('showSnackbar', {message: 'Something went wrong, please contact the administrator', color: 'primary'})
            break
    }
    return Promise.reject(error)
})



// Mixins
Vue.mixin({
    methods: {
        getSlugFromString(inputString) {
            return inputString.replace(/ /g,"-").replace(/[&/\\#,+()$~%@^'"!:*?<>{}]/g, '');
        },
        goToPatientPortalMain(redirectUrl, newTab = false) {
            let websiteUrl = process.env.VUE_APP_PATIENT_URL + `/patients-authentication?accessToken=` + store.getters.accessToken + `&userId=` + store.getters.userInfo.id + `&userType=PATIENT`;

            if (redirectUrl.length) {
                // websiteUrl += '/' + url;
                
                var base_url = websiteUrl
                var urlObj = new URL(base_url)
                urlObj.searchParams.set('redirect', redirectUrl);

                websiteUrl = urlObj.href
            }
            if (newTab) {
                window.open(websiteUrl, "_blank");
            } else {
                window.location.href = websiteUrl;
            }            
        },
        pluralize(count, noun, suffix = 's'){
            return `${count} ${noun}${count !== 1 && count !==0 ? suffix : ''}`;        

        },
        getErrorsArray(errorsObj){
            var errs = errorsObj                    
            var err_values = Object.values(errs)
            var arr = [];
            err_values.forEach(function(entry) {
                entry.forEach(function(val) {
                    arr.push(val);
                });                        
            });  
            return arr;
        },
        getImagePath(url){
            var apiUrl = process.env.VUE_APP_API_URL            
            if (url.startsWith("http") || url.startsWith("https")) {
                return url;
            } else return apiUrl +'/storage/'+url
        },
        showDoctorProfile(doctor) {
            let routeData = this.$router.resolve({name: 'DoctorDetails', params: {unique_no: doctor.unique_no, slug: this.getSlugFromString(doctor.name)}});
            window.open(routeData.href, '_blank');
            // this.selectedDoctor = doctor;
            // this.doctorProfileDialog = true
            // this.$router.push({name: 'DoctorDetails', params: {id: doctor.id}});
        },
    }
});

var vm = new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
})
vm.$mount('#app')
global.vm = vm;
